import {
  all,
  call,
  takeEvery,
  put,
  takeLatest,
  select,
} from 'redux-saga/effects';
import map from 'lodash/map';
import toUpper from 'lodash/toUpper';
import {
  changeBodyAttribute,
  manageBodyClass,
} from '@helpers/utils/manageUIByBody';

import { hasValue } from '@helpers/utils/utils';
import {
  MASTER_DATA_MODEL,
  mappingMasterData,
} from '@helpers/business/masterDataMapping';
import { getUserNameLogin } from '@helpers/cookie';
import {
  LOV_TYPE_CONSTANT,
  MASTER_DATA_PROCESS,
} from '@helpers/constants/State';

import * as action from './actions';
import * as type from './constants';

function* changeLayout({ payload: layout }) {
  try {
    if (layout === 'horizontal') {
      yield put(action.changeTopbarTheme('dark'));
      document.body.removeAttribute('data-sidebar');
      document.body.removeAttribute('data-sidebar-size');
    } else {
      yield put(action.changeTopbarTheme('light'));
    }
    yield call(changeBodyAttribute, 'data-layout', layout);
  } catch (error) {
    //
  }
}

function* changeLayoutWidth({ payload: width }) {
  try {
    yield put(action.changeSidebarType('icon'));
    yield call(changeBodyAttribute, 'data-layout-size', width);
  } catch (error) {
    //
  }
}

function* changeLeftSidebarTheme({ payload: theme }) {
  try {
    yield call(changeBodyAttribute, 'data-sidebar', theme);
  } catch (error) {
    //
  }
}

function* changeLeftSidebarType({ payload: { sidebarType, isMobile } }) {
  try {
    switch (sidebarType) {
      case 'compact':
        yield call(changeBodyAttribute, 'data-sidebar-size', 'small');
        yield call(manageBodyClass, 'sidebar-enable', 'add');
        yield call(manageBodyClass, 'vertical-collpsed', 'remove');
        break;
      case 'icon':
        yield call(changeBodyAttribute, 'data-keep-enlarged', 'true');
        yield call(manageBodyClass, 'vertical-collpsed', 'add');
        break;
      case 'condensed':
        yield call(manageBodyClass, 'sidebar-enable', 'add');
        if (window.screen.width >= 992) {
          yield call(manageBodyClass, 'vertical-collpsed', 'remove');
          yield call(manageBodyClass, 'sidebar-enable', 'remove');
          yield call(manageBodyClass, 'vertical-collpsed', 'add');
          yield call(manageBodyClass, 'sidebar-enable', 'add');
        } else {
          yield call(manageBodyClass, 'sidebar-enable', 'add');
          yield call(manageBodyClass, 'vertical-collpsed', 'add');
        }
        break;
      default:
        yield call(changeBodyAttribute, 'data-sidebar-size', '');
        yield call(manageBodyClass, 'sidebar-enable', 'remove');
        if (!isMobile)
          yield call(manageBodyClass, 'vertical-collpsed', 'remove');
        break;
    }
  } catch (error) {
    //
  }
}

function* changeTopbarTheme({ payload: theme }) {
  try {
    yield call(changeBodyAttribute, 'data-topbar', theme);
  } catch (error) {
    //
  }
}

function* showRightSidebar() {
  try {
    yield call(manageBodyClass, 'right-bar-enabled', 'add');
  } catch (error) {
    //
  }
}

function* initData() {
  try {
    yield put(action.loadingRequest());
    yield all([
      // put(action.getMasterData()),
      // call(getListUserRequest, () => {}),
      // call(getSubmittingCasesRequest),
      // call(getSavantKYCStatus),
      // call(getFCRMStatus),
      // call(getRuleCDLov),
    ]);
    yield put(action.loadingSuccess());
  } catch (error) {
    yield put(action.loadingSuccess());
  }
}

function* refreshTokenRequest({ payload, callback }) {
  try {
    yield put(action.loadingRequest());
    yield put(action.loadingSuccess());
    return callback(false);
  } catch (error) {
    yield put(action.loadingSuccess());
    return callback(false);
  }
}

export default function* globalSaga() {
  yield takeEvery(type.CHANGE_LAYOUT, changeLayout);
  yield takeEvery(type.CHANGE_LAYOUT_WIDTH, changeLayoutWidth);
  yield takeEvery(type.CHANGE_SIDEBAR_THEME, changeLeftSidebarTheme);
  yield takeEvery(type.CHANGE_SIDEBAR_TYPE, changeLeftSidebarType);
  yield takeEvery(type.CHANGE_TOPBAR_THEME, changeTopbarTheme);
  yield takeEvery(type.SHOW_RIGHT_SIDEBAR, showRightSidebar);
  yield takeEvery(type.SHOW_RIGHT_SIDEBAR, showRightSidebar);

  yield takeLatest(type.INIT_DATA, initData);

  yield takeLatest(type.REFRESH_TOKEN_REQUEST, refreshTokenRequest);
}
